export default __webpack_public_path__ + "static/media/DMSI.6e1421b0.png";